import TiremetrixFixErrorsHtml     from './tiremetrix.fix-errors.html';
import TiremetrixRegisterTiresHtml from './tiremetrix.register-tires.html';
import TiremetrixSearchTiresHtml   from './tiremetrix.search-tires.html';
import WindowFlipHtml              from '../../app-lite/core/templates/window-flip.html';

export function TiremetrixService (
  $uibModal,
  $q,
  $translate,
  companyApi,
  confirm,
  sessionObjAPI,
  workshopAPI
) {
  const Tiremetrix = function () {
    this.company = companyApi;
  };

  Tiremetrix.prototype.getAccessUrl = function (invoice = {}) {
    return workshopAPI.get('/tire_pressure_management_systems/get_access_url', invoice.vehicle_id);
  };

  Tiremetrix.prototype.isValidProduct = function (product) {
    const self = this;

    return this.company.hasIntegration('tiremetrix') && product.product_id && product.product_type === 'T';
  };

  Tiremetrix.prototype.processRegistration = function (invoice = {}, registration = {}) {
    const self    = this;
    let tireCount = 0;

    angular.forEach(invoice.invoice_items_attributes, item => {
      if (self.isValidProduct(item)) {
        tireCount += parseFloat(item.quantity);
      }
    });

    return $q.when().then(() => {
      if (tireCount && tireCount > registration.tires.length) {
        return confirm.generic('There are more tyres in the invoice than registered. Would you like to continue? PLEASE NOTE: You can register the tyres after processing the invoice.');
      }
      else if (tireCount && tireCount < registration.tires.length) {
        return confirm.generic('There are not enough tyres set for registration compared to the number of tyres sold. Would you like to continue? PLEASE NOTE: You can register the tyres after processing the invoice.');
      }

      return $q.when();
    }).then(() => {
      registration.invoice.purchase_date = registration.invoice.post_date;
      registration.vehicle.state         = registration.vehicle.plate_state;
      registration.tyres                 = registration.tires;

      return workshopAPI.post('/tire_registrations/register_tyres', registration, 'tire_registration').then((result = {}) => {
        return !result.warnings.length && !result.errors.length ?
          $q.when($translate.instant('TIREMETRIX_SPACE.TYRE_REGISTRATIONS_SENT')) :
          $uibModal.open({
            controller: 'TiremetrixFixErrorsCtrl',
            resolve: {
              tires () {
                return workshopAPI.get('/vehicle_tyre_registrations/registered_tyres_list_for_invoice', invoice.id);
              },
              errors () {
                return result.errors;
              },
              warnings () {
                return result.warnings;
              }
            },
            templateUrl: TiremetrixFixErrorsHtml,
            windowClass: 'x-lg-modal flip-container',
            windowTemplateUrl: WindowFlipHtml,
          }).result;
      });
    });
  };

  Tiremetrix.prototype.registerTires = function (invoice) {
    return $uibModal.open({
      controller: 'TiremetrixRegisterTiresCtrl',
      resolve   : {
        invoice () {
          return invoice;
        },
        customer () {
          return workshopAPI.get('/customer', invoice.customer_id);
        },
        vehicle () {
          return workshopAPI.get('/vehicle', invoice.vehicle_id);
        },
        tires () {
          return workshopAPI.get('/vehicle_tyre_registrations/registered_tyres_list_for_invoice', invoice.id);
        },
        states () {
          return workshopAPI.get('/system/state_types', null, 'states');
        }
      },
      templateUrl: TiremetrixRegisterTiresHtml,
      windowClass: 'lg-modal'
    }).result;
  };

  Tiremetrix.prototype.searchTires = function (invoice = {}, item = {}) {
    const self = this;

    return workshopAPI.get('/tire_registrations/search_for_tins', item.product_id).then(tires => {
      return tires.Message === 'An error has occurred.' ? $q.reject(tyres.ExceptionMessage) :
        $uibModal.open({
          controller: 'TiremetrixSearchTiresCtrl',
          resolve: {
            tires () {
              return tires.Tires;
            },
            item () {
              return item;
            },
            invoice () {
              return invoice;
            },
            registeredTires () {
              return item.id ? workshopAPI.get('/vehicle_tyre_registrations/registered_tyres_list_for_invoice_item', item.id) : [];
            },
            product() {
              return workshopAPI.get('/product', item.product_id);
            }
          },
          templateUrl: TiremetrixSearchTiresHtml,
          windowClass: 'x-lg-modal flip-container',
          windowTemplateUrl: WindowFlipHtml
        }).result;
    });
  };

  return Tiremetrix;
}
